module.exports = __webpack_public_path__ + "static/connect-662cdbd9c2c4c82c25c48a44a35a10e9.jpg";